import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral([''], ['']),
    _templateObject2 = _taggedTemplateLiteral(['\n  ', ';\n  line-height: ', 'px;\n  margin-right: ', 'px;\n  margin-top: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n'], ['\n  ', ';\n  line-height: ', 'px;\n  margin-right: ', 'px;\n  margin-top: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  font-size: ', ';\n  margin-top: 8px;\n'], ['\n  font-size: ', ';\n  margin-top: 8px;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  min-width: 100%;\n  margin-top: 8px;\n'], ['\n  min-width: 100%;\n  margin-top: 8px;\n']);

import styled from 'styled-components';
import { fontSize } from '@atlaskit/theme';
import { akTypographyMixins, akGridSizeUnitless } from '@atlaskit/util-shared-styles';

/**
 * Provide a styled container for form headers.
 */
var FormHeaderWrapper = styled.div(_templateObject);

/**
 * Provide a styled container for form header title.
 */
var FormHeaderTitle = styled.h1(_templateObject2, akTypographyMixins.h700, akGridSizeUnitless * 4, akGridSizeUnitless * 4);

/**
 * Provide a styled container for form header title.
 */
var FormHeaderDescription = styled.span(_templateObject3, fontSize());

/**
 * Provide a styled container for form header content.
 */
var FormHeaderContent = styled.div(_templateObject4);

export default FormHeaderWrapper;
export { FormHeaderTitle, FormHeaderDescription, FormHeaderContent };